import { ProfitAndLossMonthlyData } from "@/types/profit-and-loss-monthly-api";
import { api, withErrorHandling } from "./api";
import qs from "qs";

export const getProfitAndLossMonthly = async (
  clientId: string,
  connectionIds: string[],
  fromYear: number,
  fromMonth: number,
  toYear: number,
  toMonth: number
): Promise<ProfitAndLossMonthlyData> => {
  const response = await withErrorHandling(() =>
    api.get<ProfitAndLossMonthlyData>(
      `/clients/${clientId}/report/profit-and-loss/monthly`,
      {
        params: {
          clientId,
          fromYear,
          fromMonth,
          toYear,
          toMonth,
          connectionIds: connectionIds[0],
        },
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
      }
    )
  );
  return response.data;
};
